export interface Article {
  id: string;
  slug: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  categorySlug: string;
  image: string;
  author: string;
  date: string;
  readTime: string;
  tags: string[];
  featured: boolean;
}

export interface Category {
  name: string;
  slug: string;
  description: string;
  icon: string;
}

export const categories: Category[] = [
  {
    name: '剧情介绍',
    slug: 'plot',
    description: '深入了解《炽热之夜》的完整剧情脉络、角色关系与故事背景',
    icon: 'ri-film-line',
  },
  {
    name: '演员阵容',
    slug: 'cast',
    description: '认识《炽热之夜》台前幕后主创团队与演员介绍',
    icon: 'ri-user-star-line',
  },
  {
    name: '影评分析',
    slug: 'reviews',
    description: '专业影评人深度解析《炽热之夜》的艺术价值与社会意义',
    icon: 'ri-star-line',
  },
  {
    name: '观影指南',
    slug: 'guide',
    description: '《炽热之夜》上映时间、购票渠道与正规观影方式汇总',
    icon: 'ri-guide-line',
  },
];

export const articles: Article[] = [
  {
    id: '1',
    slug: 'chire-zhizhiye-wanzheng-juqing-jieshao',
    title: '《炽热之夜》完整剧情介绍：一场关于爱与欲望的菲律宾都市寓言',
    excerpt: '深入解读菲律宾电影《炽热之夜》的完整剧情脉络，从人物关系到故事转折，全面剖析这部融合爱情、欲望与社会现实的菲律宾情色剧情力作。',
    content: `<p>菲律宾电影《炽热之夜》（英文名：Scorching Night）是一部由菲律宾知名导演执导的情色剧情片，于近年上映后迅速引发影迷热议。影片以马尼拉繁华都市为背景，讲述了一段发生在热带夜晚的禁忌爱情故事。</p>
<h2>故事背景</h2>
<p>故事设定在菲律宾首都马尼拉，这座充满活力又暗藏矛盾的国际大都市。影片通过主人公的视角，展现了菲律宾当代社会的阶层差异、文化冲突与人性的复杂面向。马尼拉的璀璨霓虹与底层社区的昏暗街巷形成强烈对比，为影片奠定了深沉的视觉基调。</p>
<h2>主要情节</h2>
<p>影片女主角是一位来自贫困家庭的年轻女子，为了生计在夜店工作；男主角则是一位事业有成的富商，看似拥有一切却内心空虚。两人在一个偶然的炽热夜晚相遇，随后展开了一段充满激情与矛盾的关系。</p>
<p>随着剧情推进，这段关系逐渐被现实所考验——社会阶层的鸿沟、家庭的反对、以及来自周围的流言蜚语，都成为两人之间无法逾越的障碍。影片通过细腻的情感刻画和极具张力的表演，将这段禁忌之恋的甜蜜与痛苦展现得淋漓尽致。</p>
<h2>主题深度</h2>
<p>《炽热之夜》不仅是一部情色电影，更是一面折射菲律宾社会现实的镜子。影片探讨了阶级固化、性别权力关系、城市边缘群体的生存状况等深刻议题。导演以其独特的叙事手法，将情欲场面与严肃的社会批判巧妙融合，使得本片超越了普通情色片的范畴，升华为一部具有艺术价值的菲律宾剧情佳作。</p>
<h2>结局解读</h2>
<p>影片的开放式结局给观众留下了广阔的思考空间。在经历了种种考验后，两位主人公最终做出了各自的选择——这个选择既是对爱情的回答，也是对自我身份的确认。影片结尾的画面意味深长，热带夜晚的燥热逐渐散去，留下的是关于爱与人生的无尽回味。</p>`,
    category: '剧情介绍',
    categorySlug: 'plot',
    image: 'https://readdy.ai/api/search-image?query=Moody%20nighttime%20street%20scene%20in%20Manila%20Philippines%20with%20warm%20neon%20lights%20reflecting%20on%20wet%20pavement%2C%20cinematic%20color%20grading%20with%20deep%20shadows%20and%20amber%20highlights%2C%20romantic%20urban%20atmosphere%2C%20soft%20focus%20background%2C%20shallow%20depth%20of%20field%2C%20film%20photography%20aesthetic%20with%20subtle%20grain%2C%20no%20text%20no%20people%20visible&width=800&height=450&seq=article-plot-01&orientation=landscape',
    author: '光影评论',
    date: '2025-11-15',
    readTime: '8 分钟',
    tags: ['炽热之夜剧情', '菲律宾电影剧情', '情色剧情片'],
    featured: true,
  },
  {
    id: '2',
    slug: 'chire-zhizhiye-yanyuan-zhenrong-quanjie',
    title: '《炽热之夜》演员阵容全解析：认识影片中的实力派菲律宾演员',
    excerpt: '全面介绍菲律宾电影《炽热之夜》的主演阵容与幕后团队，深入了解各位演员的演艺经历与本片中的精彩表现。',
    content: `<p>《炽热之夜》汇集了菲律宾电影界多位实力派演员，他们精湛的演技为这部电影注入了灵魂。以下是本片主要演员阵容的详细介绍。</p>
<h2>女主角</h2>
<p>女主角由菲律宾当红女演员饰演，她在片中饰演一位身处社会底层却拥有坚韧灵魂的夜店舞者。这位女演员以其细腻的情感表达和大胆的表演风格著称，此前曾主演多部菲律宾独立电影。在本片中，她完美诠释了角色从绝望到觉醒的心路历程，尤其是几场情感爆发的重头戏，展现出了令人惊叹的演技张力。</p>
<h2>男主角</h2>
<p>男主角由菲律宾资深男演员担纲，他饰演一位外表光鲜但内心孤独的富商。这位演员在菲律宾影视圈拥有二十余年的演艺经验，曾多次获得菲律宾电影奖项提名。在《炽热之夜》中，他将角色表面的成功与内心的脆弱演绎得入木三分，与女主角之间的化学反应更是成为影片最大的看点之一。</p>
<h2>重要配角</h2>
<p>影片还汇聚了多位菲律宾实力派配角演员，包括饰演男主角家族成员的资深戏骨，以及饰演女主角闺蜜的新生代演员。每一位配角都为影片增添了丰富的戏剧层次，共同构建了一个真实而动人的故事世界。</p>
<h2>导演与幕后团队</h2>
<p>本片导演是菲律宾新生代导演中的佼佼者，以其对社会议题的敏锐观察和独特的视觉风格而闻名。摄影师则擅长运用热带光线与城市夜景，为影片营造出既性感又压抑的独特氛围。配乐由菲律宾知名音乐人操刀，融合传统菲律宾音乐元素与现代电子音乐，为影片增添了浓烈的地域色彩。</p>`,
    category: '演员阵容',
    categorySlug: 'cast',
    image: 'https://readdy.ai/api/search-image?query=Artistic%20silhouette%20of%20two%20figures%20standing%20close%20together%20against%20a%20warm%20golden%20sunset%20backdrop%2C%20soft%20romantic%20lighting%2C%20dreamy%20bokeh%20circles%2C%20emotional%20cinematic%20composition%2C%20deep%20rich%20warm%20tones%20of%20orange%20and%20crimson%2C%20elegant%20and%20tasteful%20artistic%20interpretation%2C%20no%20faces%20visible%2C%20minimalist%20style&width=800&height=450&seq=article-cast-01&orientation=landscape',
    author: '星光观察',
    date: '2025-11-20',
    readTime: '6 分钟',
    tags: ['炽热之夜演员', '菲律宾演员', '电影主演介绍'],
    featured: true,
  },
  {
    id: '3',
    slug: 'chire-zhizhiye-yingping-fenxi',
    title: '《炽热之夜》深度影评：菲律宾情色电影的艺术突破',
    excerpt: '从艺术角度深度解析《炽热之夜》的叙事手法、视觉风格与社会意义，探讨这部菲律宾电影为何能在情色片类型中脱颖而出。',
    content: `<p>在菲律宾电影的谱系中，《炽热之夜》无疑是一部值得深入讨论的作品。它既不是那种单纯以感官刺激为目的的情色片，也不是故作深沉的文艺片，而是在两者之间找到了一种微妙的平衡。</p>
<h2>叙事结构的精妙设计</h2>
<p>影片采用非线性叙事结构，通过闪回与现实的交替，逐渐拼凑出两位主人公的完整故事。这种叙事手法的运用并非炫技，而是精准地服务于情感表达——观众随着碎片化的记忆逐渐理解角色行为背后的动机，这种体验远比线性叙事更加深刻且富有参与感。</p>
<h2>视觉语言的艺术追求</h2>
<p>影片的摄影风格令人印象深刻。摄影师大量使用暖色调与高对比度光影，将马尼拉夜晚的热带气息渲染得浓郁而迷人。尤其在亲密场景的处理上，镜头既保持了必要的暧昧美感，又避免了低俗的窥视感，展现了极高的审美水准。每一个画面都经过精心构图，犹如一幅幅充满张力的摄影作品。</p>
<h2>社会批判的深度嵌入</h2>
<p>最令人称道的是影片对菲律宾社会现实的批判性呈现。导演没有选择说教式的方式，而是将阶级分化、性别不平等、城市边缘人的困境等议题自然融入到故事情节中。当观众沉浸在两位主人公的情感纠葛中时，这些社会议题也在无声地叩击着每个人的内心。</p>
<h2>为何本片值得一看</h2>
<p>对于华语观众而言，《炽热之夜》提供了一个难得的窗口，让我们得以窥见菲律宾当代社会的一角。影片既有足够的娱乐性——动人的爱情故事、出色的演员表演、精美的视觉呈现；又具备相当的思考深度——对社会现实的洞察、对人性的探讨、对爱的本质的追问。这正是本片能够超越类型局限，成为一部值得反复品味的菲律宾剧情佳作的原因。</p>`,
    category: '影评分析',
    categorySlug: 'reviews',
    image: 'https://readdy.ai/api/search-image?query=Vintage%20film%20projector%20casting%20warm%20golden%20light%20beam%20through%20subtle%20dust%20particles%20in%20a%20dark%20room%2C%20cinematic%20equipment%20aesthetic%2C%20rich%20amber%20and%20sepia%20tones%2C%20nostalgic%20movie%20theater%20atmosphere%2C%20soft%20shadows%20and%20warm%20highlights%2C%20elegant%20artistic%20composition%2C%20no%20text%20no%20people&width=800&height=450&seq=article-review-01&orientation=landscape',
    author: '银幕观察室',
    date: '2025-11-25',
    readTime: '7 分钟',
    tags: ['炽热之夜影评', '菲律宾电影评论', '情色电影艺术'],
    featured: true,
  },
  {
    id: '4',
    slug: 'chire-zhizhiye-guankan-qudao-zhengui',
    title: '《炽热之夜》正规观看指南：上映信息与观影渠道汇总',
    excerpt: '整理菲律宾电影《炽热之夜》在中国大陆及海外的正规观看渠道，包括流媒体平台、影院上映信息，确保影迷通过合法途径欣赏本片。',
    content: `<p>对于期待观看《炽热之夜》的影迷来说，了解正规的观看渠道至关重要。本文为您整理了本片在各地区的上映信息与观影方式。</p>
<h2>菲律宾院线上映</h2>
<p>《炽热之夜》在菲律宾本土院线的上映获得了不错的票房成绩。影片在马尼拉、宿务、达沃等主要城市的影院均有排片。如果您身处菲律宾，可以通过当地主流购票平台查询具体排片时间。</p>
<h2>国际电影节展映</h2>
<p>本片曾在多个国际电影节上进行展映，包括东京国际电影节、釜山国际电影节等亚洲重要电影盛会。在电影节期间的放映通常附带导演问答环节，是深入了解影片创作背景的绝佳机会。</p>
<h2>流媒体平台上线</h2>
<p>随着菲律宾电影在国际流媒体平台上的能见度不断提高，《炽热之夜》已陆续登陆多个主流流媒体平台。影迷可以通过订阅相关服务观看本片高清版本。建议关注影片官方社交媒体账号，获取最新的流媒体上线信息。</p>
<h2>观影注意事项</h2>
<p>需要提醒影迷的是，本片包含成人内容，部分版本可能经过不同程度的剪辑处理。为获得最完整的观影体验，建议选择未删减版本进行观看。同时，请务必通过正规渠道观看，支持正版影视内容，尊重电影创作者的劳动成果。</p>
<h2>中文资源获取</h2>
<p>对于希望观看中文字幕版本的华语观众，请留意各大正版流媒体平台的中文区更新情况。部分平台可能会在后续推出官方中文字幕版本，届时将为华语观众提供更便捷的观影体验。</p>`,
    category: '观影指南',
    categorySlug: 'guide',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20portrait%20photography%20backdrop%20with%20warm%20studio%20lighting%20and%20soft%20shadows%2C%20sophisticated%20cream%20and%20amber%20color%20palette%2C%20subtle%20texture%20of%20velvet%20curtains%2C%20cinematic%20Hollywood%20glamour%20atmosphere%2C%20no%20person%20visible%2C%20rich%20warm%20tones%2C%20editorial%20photography&width=800&height=450&seq=article-guide-01&orientation=landscape',
    author: '观影指南编辑部',
    date: '2025-12-01',
    readTime: '5 分钟',
    tags: ['炽热之夜观看', '菲律宾电影观看渠道', '正版观影'],
    featured: false,
  },
  {
    id: '5',
    slug: 'chire-zhizhiye-beihou-gushi',
    title: '《炽热之夜》幕后故事：你不知道的拍摄秘辛',
    excerpt: '揭秘菲律宾电影《炽热之夜》的拍摄幕后，从选角过程到拍摄挑战，了解这部作品诞生背后的真实故事。',
    content: `<p>每一部优秀的电影背后都有一段不为人知的拍摄故事，《炽热之夜》也不例外。让我们走进幕后，了解这部菲律宾话题之作的创作历程。</p>
<h2>选角的曲折过程</h2>
<p>据导演透露，女主角的选角过程历时近半年。剧组面试了超过五十位女演员，最终才锁定了现在的女主角。导演表示，他需要的不仅是一位能够胜任情色戏份的演员，更需要的是一位能够准确传达角色内心挣扎的表演者。</p>
<h2>实景拍摄的挑战</h2>
<p>为了营造真实感，影片大量采用实景拍摄。马尼拉街头的夜景戏份全部在真实环境中完成，剧组常常需要在深夜至凌晨工作，以避开白天的喧嚣人群。热带的潮湿气候和不可预测的天气变化，给拍摄带来了诸多变数，但也为影片增添了不可复制的真实质感。</p>
<h2>亲密戏份的专业处理</h2>
<p>对于影片中的情色场景，剧组采取了极为专业的处理方式。拍摄现场设置了私密的封闭环境，仅保留必要的核心工作人员。在开拍前，导演与演员进行了充分的沟通与排练，确保每个镜头都是在演员完全舒适和自愿的前提下完成。</p>
<h2>后期制作的精细打磨</h2>
<p>影片的后期制作历时近四个月。剪辑师与导演反复推敲每一个镜头的取舍，力求在叙事节奏与艺术表达之间找到最佳平衡。配乐的制作同样精益求精，音乐团队创作了超过两小时的原创音乐，最终影片中使用的仅为其中精选的四十余分钟。</p>`,
    category: '影评分析',
    categorySlug: 'reviews',
    image: 'https://readdy.ai/api/search-image?query=Professional%20film%20production%20studio%20environment%20with%20warm%20ambient%20lighting%2C%20elegant%20equipment%20arrangement%2C%20soft%20cream%20and%20gold%20tones%2C%20sophisticated%20creative%20workspace%20atmosphere%2C%20cinematic%20color%20grading%2C%20high-end%20commercial%20photography%20style%2C%20clean%20and%20organized%20composition%2C%20no%20people%20visible&width=800&height=450&seq=article-bts-01&orientation=landscape',
    author: '幕后档案',
    date: '2025-12-05',
    readTime: '6 分钟',
    tags: ['炽热之夜幕后', '菲律宾电影拍摄', '电影制作故事'],
    featured: false,
  },
  {
    id: '6',
    slug: 'feilvbin-qingse-dianying-fazhan',
    title: '菲律宾情色电影发展简史：从边缘到主流的演变之路',
    excerpt: '回顾菲律宾情色剧情电影的发展历程，了解菲律宾电影产业如何在审查制度与社会观念变迁中寻找表达空间。',
    content: `<p>菲律宾电影产业拥有悠久而丰富的历史，而情色剧情片作为其中的一个重要类型，经历了从地下到地上、从边缘到主流的演变过程。</p>
<h2>早期探索时期</h2>
<p>菲律宾情色电影的萌芽可以追溯到上世纪七十年代。彼时，随着社会风气的逐渐开放和电影审查制度的松动，一批大胆探索成人主题的菲律宾电影开始出现。这些早期作品虽然制作相对粗糙，但开创了菲律宾电影探索情欲主题的先河。</p>
<h2>黄金发展期</h2>
<p>进入八十至九十年代，菲律宾情色电影迎来了一个高速发展的黄金时期。一批才华横溢的导演将艺术追求融入到情色类型片中，创作出了许多既具商业价值又有艺术水准的作品。这一时期也涌现出了多位至今仍被影迷怀念的银幕女神。</p>
<h2>当代转型</h2>
<p>进入二十一世纪，随着互联网的普及和全球化的影响，菲律宾情色电影面临着新的挑战与机遇。一方面，成人内容的获取渠道日益多元化，传统的院线情色片面临市场萎缩；另一方面，新一代导演开始探索将情色元素与严肃社会议题相结合的创作路径，《炽热之夜》正是这一转型趋势的代表作品。</p>
<h2>国际认可</h2>
<p>近年来，多部菲律宾情色剧情片在国际电影节上获得了认可，这不仅提升了菲律宾电影的国际影响力，也为本国电影人争取到了更多的创作空间。国际影评界对菲律宾电影中大胆而真诚的情感表达给予了高度评价，认为其展现出了一种不同于西方情色片的独特美学。</p>`,
    category: '影评分析',
    categorySlug: 'reviews',
    image: 'https://readdy.ai/api/search-image?query=Warm%20cinematic%20abstract%20background%20with%20soft%20amber%20and%20deep%20crimson%20tones%2C%20elegant%20bokeh%20light%20particles%20floating%20in%20darkness%2C%20subtle%20film%20grain%20texture%20overlay%2C%20sophisticated%20movie%20premiere%20atmosphere%2C%20rich%20warm%20color%20grading%2C%20minimalist%20yet%20dramatic%20composition%20with%20gentle%20light%20gradients&width=800&height=450&seq=article-history-01&orientation=landscape',
    author: '电影史话',
    date: '2025-12-10',
    readTime: '7 分钟',
    tags: ['菲律宾情色电影', '菲律宾电影历史', '电影产业发展'],
    featured: false,
  },
  {
    id: '7',
    slug: 'chire-zhizhiye-juese-jiedu',
    title: '《炽热之夜》角色深度解读：每个人物背后的隐喻',
    excerpt: '逐个人物剖析《炽热之夜》中的角色设定与象征意义，解读导演通过角色群像传达的社会思考。',
    content: `<p>在《炽热之夜》中，每个角色都不只是一个简单的故事元素，而是承载着导演对社会现实的深层思考。</p>
<h2>女主角：被压抑的灵魂</h2>
<p>女主角的形象代表的是菲律宾社会中那些身处底层、被主流叙事忽略的女性群体。她在夜店工作的设定并非简单的职业选择，而是暗喻了一个缺乏向上流动渠道的社会现实。影片中她每一次的情感表达与身体展示，都不是被动的被观看，而是她夺回身体自主权的过程。</p>
<h2>男主角：权力的困境</h2>
<p>男主角虽然拥有社会地位与财富，却在情感与道德层面深陷困境。他的角色揭示了上层社会精英的精神危机——物质的丰裕并不能填补内心的空洞。他与女主角之间的关系，某种程度上反映的是权力不对等下的爱是否可能的哲学命题。</p>
<h2>配角群像：社会的横截面</h2>
<p>影片中的每一位配角都有着明确的社会指向意义。男主角家族的成员代表了保守的传统力量；女主角的同事与朋友则构成了城市底层互助的温暖社群。导演通过这些配角的精心设计，在有限的银幕时间内构建了一幅菲律宾当代社会的微型画卷。</p>`,
    category: '影评分析',
    categorySlug: 'reviews',
    image: 'https://readdy.ai/api/search-image?query=Warm%20theatrical%20stage%20lighting%20with%20dramatic%20spotlight%20effect%20on%20an%20empty%20stage%2C%20rich%20crimson%20and%20gold%20theater%20curtains%2C%20elegant%20performance%20venue%20atmosphere%2C%20deep%20shadows%20with%20warm%20grain%20texture%2C%20cinematic%20composition%2C%20sophisticated%20minimalist%20theater%20aesthetic&width=800&height=450&seq=article-char-01&orientation=landscape',
    author: '光影评论',
    date: '2025-12-15',
    readTime: '5 分钟',
    tags: ['炽热之夜角色', '电影人物分析', '菲律宾电影解读'],
    featured: false,
  },
  {
    id: '8',
    slug: 'chire-zhizhiye-changjing-paishe-didian',
    title: '《炽热之夜》取景地巡礼：马尼拉拍摄地点全攻略',
    excerpt: '跟随《炽热之夜》的镜头，探访影片在马尼拉的标志性拍摄地点，感受菲律宾首都的独特魅力与电影氛围。',
    content: `<p>《炽热之夜》在马尼拉的多个标志性地点取景拍摄，这些场景不仅为影片增添了浓厚的地域色彩，也成为影迷们向往的打卡圣地。</p>
<h2>马尼拉湾日落大道</h2>
<p>影片中最令人难忘的浪漫场景之一——男女主角在海滨散步的片段——正是在马尼拉湾日落大道拍摄的。这条沿海大道以壮丽的日落景色闻名，橘红色的晚霞映照在海面上，与影片的暖色调美学完美契合。</p>
<h2>王城区历史街区</h2>
<p>影片中多场重要的对话戏份取景于马尼拉历史悠久的王城区。那些有着数百年历史的西班牙殖民时期建筑，为影片增添了厚重的历史感与文化底蕴。鹅卵石街道、古老的教堂与斑驳的墙面，共同营造出了令人沉醉的怀旧氛围。</p>
<h2>马卡蒂金融区夜景</h2>
<p>男主角商业活动的相关场景主要在马卡蒂中央商务区拍摄。高耸的摩天大楼、璀璨的城市灯光与流光溢彩的街道，展现了马尼拉作为国际大都市的繁华面貌，也与女主角所在社区的昏暗形成了鲜明的视觉对比。</p>
<h2>博尼法西奥环球城</h2>
<p>影片中几场现代都市生活场景取景于博尼法西奥环球城。这个新兴的城市区域以其时尚的建筑、精致的餐厅和充满活力的街头文化而著称，为影片注入了当代菲律宾都市的现代气息。</p>`,
    category: '观影指南',
    categorySlug: 'guide',
    image: 'https://readdy.ai/api/search-image?query=Warm%20golden%20sunset%20over%20a%20tropical%20bay%20with%20palm%20tree%20silhouettes%2C%20Manila%20Bay%20atmosphere%2C%20cinematic%20color%20grading%20with%20rich%20amber%20and%20coral%20hues%2C%20soft%20reflections%20on%20calm%20water%2C%20romantic%20tropical%20evening%20vibe%2C%20elegant%20composition%2C%20no%20people%20visible&width=800&height=450&seq=article-location-01&orientation=landscape',
    author: '旅行电影志',
    date: '2025-12-18',
    readTime: '5 分钟',
    tags: ['炽热之夜取景地', '马尼拉旅游', '电影场景巡礼'],
    featured: false,
  },
];

export const aboutData = {
  brandName: '炽热之夜电影资讯站',
  tagline: '专注菲律宾优质电影内容的华语影迷社区',
  introduction: `<p>炽热之夜电影资讯站成立于2025年，是国内最早专注于菲律宾电影《炽热之夜》及相关菲律宾优质影视内容的中文资讯平台。我们的使命是搭建华语影迷与菲律宾电影之间的桥梁，让更多中国观众能够深入了解并欣赏菲律宾电影的独特魅力。</p>
<p>从《炽热之夜》出发，我们逐步拓展至更广泛的菲律宾电影领域——从经典老片到最新院线作品，从商业大片到独立艺术电影，致力于为华语影迷提供全面、专业、深度的菲律宾电影资讯与评论。</p>`,
  reputation: [
    {
      quote: '这个网站让我第一次真正了解了菲律宾电影的魅力。《炽热之夜》的剧评让我看到了这部作品背后的深意，远不止表面的情色标签。',
      author: '张先生',
      role: '资深影迷',
    },
    {
      quote: '作为电影研究者，我很欣赏这个平台对菲律宾电影的专业态度。文章质量高，分析深入，为华语世界了解菲律宾电影提供了宝贵的窗口。',
      author: '李教授',
      role: '电影学者',
    },
    {
      quote: '找了好久的《炽热之夜》观影指南，终于在这里看到了详细的整理。内容靠谱，更新及时，已经推荐给了身边所有喜欢菲律宾电影的朋友。',
      author: '王小姐',
      role: '电影爱好者',
    },
  ],
  contact: {
    email: 'contact@chirezhizhiye.ph',
    wechat: 'chirezhizhiye_film',
    weibo: '@炽热之夜电影资讯站',
  },
};

export const faqData = [
  {
    question: '《炽热之夜》是什么类型的电影？',
    answer: '《炽热之夜》是一部菲律宾情色剧情电影，融合了爱情、欲望与社会现实等元素。影片以马尼拉为背景，讲述了一段发生在社会阶层差异之下的禁忌爱情故事。本片不仅仅是情色片，更是一部具有社会批判深度的菲律宾剧情佳作。',
  },
  {
    question: '《炽热之夜》在哪里可以观看？',
    answer: '《炽热之夜》可在菲律宾本土影院及部分国际电影节进行观看。此外，本片已陆续登陆多个国际主流流媒体平台。建议关注本片官方社交媒体账号获取最新的上线信息，并通过正规渠道观看，支持正版影视内容。',
  },
  {
    question: '《炽热之夜》有中文字幕版本吗？',
    answer: '部分流媒体平台可能提供中文字幕选项，具体情况视各平台的内容本地化策略而定。建议在订阅相关流媒体服务后查看字幕语言设置。本资讯站将持续关注并更新中文字幕版本的获取信息。',
  },
  {
    question: '《炽热之夜》的演员有哪些？',
    answer: '《炽热之夜》汇集了多位菲律宾实力派演员，包括当红女演员饰演的女主角和资深男演员饰演的男主角，以及多位菲律宾电影界的知名配角演员。详细的演员介绍请查看本站「演员阵容」分类下的文章。',
  },
  {
    question: '《炽热之夜》适合什么年龄段的观众？',
    answer: '《炽热之夜》包含成人内容，建议18岁以上观众观看。影片涉及情色场景和成人主题，不适合未成年人观看。请观众在观看前确认自己符合年龄要求，并在适宜的场合进行观看。',
  },
];